const QUEUE_SEND_SUCCEEDED = "QUEUE_SEND_SUCCEEDED";
const QUEUE_SEND_FAILED = "QUEUE_SEND_FAILED";
const QUEUE_SEND_REQUESTED = "QUEUE_SEND_REQUESTED";
const QUEUE_ITEM_ADDED = "QUEUE_ITEM_ADDED";
const QUEUE_ITEMS_RESTORED = "QUEUE_ITEMS_RESTORED";
const QUEUE_NETWORK_CHANGED = "QUEUE_NETWORK_CHANGED";
const CHECK_NETWORK_CONNECTION = "CHECK_NETWORK_CONNECTION";
const QUEUE_ITEM_RETRY = "QUEUE_ITEM_RETRY";
const QUEUE_ITEM_REMOVED = "QUEUE_ITEM_REMOVED";

export default {
	QUEUE_SEND_SUCCEEDED,
	QUEUE_SEND_FAILED,
	QUEUE_SEND_REQUESTED,
	QUEUE_ITEM_ADDED,
	QUEUE_ITEMS_RESTORED,
	QUEUE_NETWORK_CHANGED,
	CHECK_NETWORK_CONNECTION,
	QUEUE_ITEM_RETRY,
	QUEUE_ITEM_REMOVED,
};
